import { Directive, TemplateRef } from '@angular/core';
import { GlobalModalService } from '../services/global-modal.service';

@Directive({
  selector: 'ng-template[thGlobalModal]'
})
export class GlobalModalDirective {
  constructor(template: TemplateRef<unknown>, globalModalService: GlobalModalService) {
    globalModalService.template = template;
  }
}
